import React from 'react';

import { FluxoProvider } from './fluxos';
import { ReceitaDespesaProvider } from './receitasDespesas';

function FinanceiroProvider({ children }) {
  return <FluxoProvider>
    <ReceitaDespesaProvider>{children}</ReceitaDespesaProvider>
  </FluxoProvider>
}

export default FinanceiroProvider;
